/* eslint-disable */
import React from "react";
import { Card, Title, Text, Divider, List } from "@mantine/core";

export default function CollectingDataCard() {
  return (
    <Card shadow="sm" radius="md" withBorder>
      <Title order={3}>Collecting and Using Your Personal Data</Title>
      <Divider my="md" />
      <Title order={4}>Types of Data Collected</Title>

      <Text mt="sm" weight={700}>
        Personal Data
      </Text>
      <Text>
        While using our Service, we may ask you to provide personally
        identifiable information, including but not limited to:
      </Text>
      <List spacing="xs" mt="sm">
        <List.Item>Email address</List.Item>
        <List.Item>First name and last name</List.Item>
        <List.Item>Phone number</List.Item>
        <List.Item>Usage Data</List.Item>
      </List>

      <Text mt="md" weight={700}>
        Usage Data
      </Text>
      <Text>
        Collected automatically and may include IP address, browser type,
        browser version, the pages of our Service that you visit, the time and
        date of your visit, time spent on those pages, unique device identifiers
        and other diagnostic data.
      </Text>

      <Text mt="md">
        When you access the Service by or through a mobile device, we may
        collect certain information automatically, including the device type,
        unique ID, IP address, OS, and mobile browser type.
      </Text>
    </Card>
  );
}
